var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.012 1.987v.002a2.95 2.95 0 01-.91 2.148l-.328.315.442.108c.672.165 1.25.517 1.66.95.41.435.635.935.635 1.394 0 .246-.065.41-.165.53-.104.123-.266.221-.5.295-.48.15-1.17.17-2.003.17 0 0 0 0 0 0H2.93c-.833 0-1.522-.019-2.002-.17-.234-.073-.396-.172-.5-.295-.1-.119-.165-.284-.165-.53 0-.459.225-.96.636-1.394.41-.433.988-.785 1.658-.95L3 4.452l-.33-.315a2.939 2.939 0 01-.905-2.147h0v-.005C1.758 1.4 1.946.97 2.23.688 2.515.405 2.917.25 3.376.25h.012c.462 0 .864.155 1.15.439.284.282.474.711.474 1.298z",
    stroke: "#000",
    strokeWidth: 0.5
  })));
}
export default SvgAvatarSmall;